export default __webpack_public_path__ + "static/media/rndpage3-3.760fd6ca.png";